import React, { useState, useEffect } from 'react'
import { Button,Container, IconButton } from '@mui/material'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import { Link } from 'react-router-dom';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import useMediaQuery from "@mui/material/useMediaQuery";
import fetchData from '../assets/data'; 
import { useParams } from 'react-router-dom';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../components/Config';
import { useSnackbar } from 'notistack';
import axios from 'axios'; 
import Cookies from 'js-cookie';

const ONeOffPaymentDetails = () => {

    const { id } = useParams();
  const { paymenId } = useParams();

    const [findMorcards, setFindMorCards] = useState([]);

    const { enqueueSnackbar } = useSnackbar();
    const [account_holder_name, setaccount_holder_name] = useState("");
    const [bank_account_number, setbank_account_number] = useState("");
    const [sort_code, setsort_code] = useState("");
    const [has_gas_boiler, sethas_gas_boiler] = useState(false);
    const [accept_terms, setaccept_terms] = useState(false);
    const [receive_news_and_offers, setreceive_news_and_offers] = useState(false);
    const navigate = useNavigate();


  const simulateAPIRequest = async (url, method, data) => {
    try {
      const token = Cookies.get('token');
      const response = await axios({
        method,
        url,
        data,
        headers: {
          Authorization: `Bearer ${token}` 
        }
      });
        return response;
        } catch (error) {
          if (error.response && error.response.data && error.response.data.message) {
              enqueueSnackbar(error.response.data.message, { variant: 'error' });
          } else {
              enqueueSnackbar('An error occurred', { variant: 'error' });              
          }
        }
    };

  const handlepaymentDetail = async (account_holder_name, bank_account_number, sort_code, has_gas_boiler, accept_terms, receive_news_and_offers) => {
    if (!account_holder_name || !bank_account_number || !sort_code || !has_gas_boiler || !accept_terms ) {
      enqueueSnackbar('Please fill in all fields', { variant: 'error' });


      return paymenId, id;
    }
    
    const url = `${API_BASE_URL}/plans/details/${paymenId}/`;
    const method = 'PUT';
    const data = {
      account_holder_name: account_holder_name,
      bank_account_number: bank_account_number,
      sort_code: sort_code,
      accept_terms: accept_terms,
      has_gas_boiler: has_gas_boiler,
      receive_news_and_offers: receive_news_and_offers,
    };
    
    try {
      await simulateAPIRequest(url, method, data);
      enqueueSnackbar('Details saved successfully', { variant: 'success' });
      navigate(`/`);
    } catch (error) {
      enqueueSnackbar('Failed to save details', { variant: 'error' });
      
      
    }
  };
  

  const handleAccountHolderName = (e) => {
    setaccount_holder_name(e.target.value);
  };
  
  const handleBankAccountNumber = (e) => {
    setbank_account_number(e.target.value);
  };
  
  const handleSortCode = (e) => {
    setsort_code(e.target.value);
  };
  
  const handleHasGasBoiler = (e) => {
    sethas_gas_boiler(e.target.checked);
  };
  
  const handleAcceptTerms = (e) => {
    setaccept_terms(e.target.checked);
  };
  
  const handleNewsandOffers = (e) => {
    setreceive_news_and_offers(e.target.checked)
  };

  
  


    const [axpended, setaxpended] = useState(false);
    const handelCards = () => {
        setaxpended(!axpended)
    }
    const match1990 = useMediaQuery("(max-width:450px)");
    const checkEidth = window.innerWidth
    useEffect(() => {
        if (checkEidth <= 450) {
            setaxpended(true)
        }
    }, [checkEidth])


    useEffect(() => {
        fetchData(id, setFindMorCards);
      }, [id]);
    


    return (
        <Container maxWidth="xl">
            <div className='main_div_find'>

                <div className="box_one_find" style={{ height: "fit-content" }}>
                    <div className='check_stp1'>
                        <p>Step 2 of 2</p>
                        <h1>Payment Details</h1>
                        <form className='form_dabits'>
                            <div>
                                <label htmlFor="1">Name of Account Holder</label>
                                <input type="text" id='1' placeholder='First Name' onChange={handleAccountHolderName}/>
                            </div>
                            <div>
                                <label htmlFor="2">Bank Account Number</label>
                                <input type="text" placeholder='Bank Account Number' id='2' onChange={handleBankAccountNumber}/>
                            </div>
                            <div>
                                <label htmlFor="3">Sort Code</label>
                                <input type="text" placeholder='Sort Code' id='3' onChange={handleSortCode}/>
                            </div>

                        </form>
                            <div className="labl_div_pay">
                                <h1 className='m-0 cons_h1'>Consent</h1>
                                <label className="container">I confirm I have a gas boiler. It is connected to mains gas and in good working order( required)
                                    <input type="checkbox" onChange={handleHasGasBoiler}/>
                                    <span className="checkmark"></span>
                                </label>
                                <label className="container">I accept the Wecare Terms of <Link to="/Terms" className='term_and_Agre'>Service Agreement (required)</Link>
                                    <input type="checkbox" onChange={handleAcceptTerms} />
                                    <span className="checkmark"></span>
                                </label>
                                <label className="container">Tick this box if you want to occasionally receive news and offers from us. We won’t spam     you, and you can unsubscribe at any time
                                    <input type="checkbox" onChange={handleNewsandOffers}/>
                                    <span className="checkmark"></span>
                                </label>
                                <Button variant="contained" className='paymint_btn anka_tag'
                                onClick={() => handlepaymentDetail(account_holder_name, bank_account_number, sort_code, has_gas_boiler, accept_terms, receive_news_and_offers)}
                                >
                                Pay By Card
                                </Button>
                            </div>
                    </div>
                    <p className='your_info'>Your information is in safe hands! <br />
                        We use the latest online security technology (SSL) for your own peace of mind. Look for the padlock in your browser address bar</p>
                </div>

                <div className="box_celected_plans oneRepaiers_card_plan" style={{ height: axpended ? "150px" : "fit-content" }}>
                    {axpended ? (
                        <IconButton className='icons_expended' onClick={handelCards}>
                            <ArrowBackIosRoundedIcon />
                        </IconButton>
                    ) : null}
                    {findMorcards.map((item, i) => (
                        <><div key={i}>
                        <div className="selected_plan_div">
                            <span>
                                <p>Selected Product</p>
                                <h1>{item?.title}</h1>
                                <p className="m-0">{item?.ser}</p>
                            </span>
                            <img src={item?.img} alt="icons" />
                        </div>
                        <div className="cards_actions mt">
                            <div className="cards_actions">
                            {item?.working.map((item, i) => (
                                <div className="working" key={i}>
                                <CheckCircleOutlineRoundedIcon className="iconmark" />{item}
                                </div>
                            ))}
                            </div>
                            <div className="cards_actions">
                            {item?.notworking?.map((item, i) => (
                                <div className="notwarking" key={i}>
                                <CancelOutlinedIcon className="notwar" />
                                <span className="spanundesr">{item}</span>
                                </div>
                            ))}
                            </div>
                            <div className="view_div">
                            <div className='document_div'>
                                <h1>WeCare Documents</h1>
                                    <p>We want to ensure that you have chosen the correct product or service.</p>
                                    <br />
                                    <p>Please read the Wecare  <Link to="/Term" className='term_and_Agre'>Terms of Service Agreement</Link></p>
                            </div>
                            </div>
                        </div>
                        <div className="month_div">
                            <h1>Total Price</h1>
                            <span className="d-flex align-items-baseline">
                            <h2>{item?.price}</h2>p/m
                            </span>
                        </div>
                        <p className='desc_dabid'>
                            If you choose this service, the cost is a one-off payment which will be taken prior to deployment of our approved Wecare engineer. This one-off payment includes all parts and labour. We reserve the right to reject a repair if we aren’t able to repair your boiler. In this instance we will refund your payment in full.
                        </p>
                        </div>
                        <div className="month_div">
                            <h1 className='mb-3'>Cancellation</h1>
                        </div>
                        <p className='desc_dabid'>You are entitled to a 14-day cooling-off period, during which you may cancel your one-off repair. This cooling-off period begins on the day your one-off repair request is accepted.</p>
                        <p className='desc_dabid'>Please be aware that once the job has commenced, cancellation is no longer possible, and you will be responsible for any associated costs incurred. </p>
                        </>

                        ))}
                    <IconButton className='icons_expended_bot' onClick={handelCards}>
                        <ArrowBackIosRoundedIcon />
                    </IconButton>
                </div>
            </div>
        </Container>

    )
}

export default ONeOffPaymentDetails
